module.exports = __webpack_public_path__ + "img/dp158_09.565aa3af.jpg";